import { useState, useEffect } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineIndicator() {
  const [offline, setOffline] = useState(navigator.onLine === false);

  useEffect(() => {
    const sync = () => setOffline(navigator.onLine === false);
    const events = ["offline", "online", "focus", "visibilitychange"];
    events.forEach((e) => window.addEventListener(e, sync));
    const timer = setInterval(sync, 5000);
    return () => { events.forEach((e) => window.removeEventListener(e, sync)); clearInterval(timer); };
  }, []);

  if (!offline) return null;

  return (
    <div
      data-testid="offline-indicator"
      className="fixed top-0 left-0 right-0 z-[9999] bg-amber-600 text-white text-center text-sm py-1.5 px-4 flex items-center justify-center gap-2"
      role="alert"
    >
      <WifiOff className="w-4 h-4 shrink-0" />
      <span>You're offline — browsing cached menu</span>
    </div>
  );
}
